import Header from "@/components/header";
import TagReplacer from "@/components/replaceTags";
import DiscountFormByCustomerGroup from "@/modules/discount/discountFormByCustomerGroup/discountFormByCustomerGroup";
import DiscountGroupInfo from "@/modules/discount/groupInfo/discountGroupInfo";
import { Alert, Stack } from "@mantine/core";
import { useLocation } from "react-router-dom";

function CreateDiscountMessage() {
  const { state } = useLocation();
  return (
    <Stack h="100svh">
      <Header showHome title="ایجاد تخفیف" />
      <Stack px="md">
        <DiscountGroupInfo
          header=""
          count={state?.count || 0}
          title={state?.group?.name || state?.group?.title || ""}
        />
      </Stack>
      <Stack px="md">
        <Alert color="gray" title="متن انتخابی:">
          <TagReplacer
            size="sm"
            c="gray"
            tags={[]}
            text={state?.selectedTemplate?.text || ""}
          />
        </Alert>
      </Stack>
      <Stack
        px="md"
        styles={{
          root: {
            flexGrow: 1,
          },
        }}
      >
        <DiscountFormByCustomerGroup />
      </Stack>
    </Stack>
  );
}

export default CreateDiscountMessage;
